import { CheckBox } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  InputAdornment,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { DatePicker, DateValidationError } from "@mui/x-date-pickers";
import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { padZerosLeft } from "../../../commons/helpers/StringHelper";
import { PTR_LENGTH } from "../../../constante/produits";
import { Magasin } from "../../../models/Magasin";
import { Planogramme } from "../../../models/Planogramme";
import { ProduitQuantite } from "../../../models/ProduitQuantite";
import { RequestToSend } from "../../../models/RequestToSend";
import {
  addRequestToSend,
  addRequestsToSend,
} from "../../../redux/features/appStateSlice";
import { planoAPI } from "../../../redux/features/cache";
import { useAppDispatch, useAppSelector } from "../../../redux/store";
import { getModalStyle } from "../../modalStyle";
import GenericModal from "../modals/GenericModal";
import PlanoProduitsModal from "../modals/PlanoProduitsModal";
import PTRModal from "../modals/PTRModal";

interface IModificationLotMagasins {
  storePlanograms: Planogramme[];
  productNumber: number;
  setOpenModalEdit: Dispatch<SetStateAction<boolean>>;
  setSelectedRow: Dispatch<SetStateAction<number | null>>;
  setListMags: Dispatch<SetStateAction<Magasin[]>>;
}

export const ModificationLotMagasins = (props: IModificationLotMagasins) => {
  const {
    storePlanograms,
    productNumber,
    setOpenModalEdit,
    setSelectedRow,
    setListMags,
  } = props;

  const dispatch = useAppDispatch();
  const planogramManagementRights = useAppSelector(
    (state) => state.appState.prod_plano
  );

  const { data: ensemble = [] } =
    planoAPI.endpoints.getEnsemble.useQuery(productNumber);
  const [deletePlanogramme] =
    planoAPI.endpoints.deletePlanogramme.useMutation();
  const [updatePlanogramme] =
    planoAPI.endpoints.updatePlanogramme.useMutation();
  const [updatePlanogrammeProduits] =
    planoAPI.endpoints.updatePlanogrammeProduits.useMutation();

  const data = storePlanograms[0];
  const [showModalPlanoProduits, setShowModalPlanoProduits] =
    useState<boolean>(false);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isValid, setIsValid] = useState<boolean>(false);
  const [onFloorTransferDate, setOnFloorTransferDate] = useState<any>();
  const [offFloorTransferDate, setOffFloorTransferDate] = useState<any>();
  const [ptr, setPtr] = useState<number | null>(null);
  const [ensembleValues, setEnsembleValues] = useState<ProduitQuantite[]>([]);
  const [planoQuantity, setPlanoQuantity] = useState<number>(1);
  const [plateau, setPlateau] = useState<number | null>(null);
  const [remplacer, setRemplacer] = useState<boolean>(true);

  const [error, setError] = React.useState<DateValidationError | null>(null);

  const errorMessage = React.useMemo(() => {
    error === null ? setIsValid(true) : setIsValid(false);
    switch (error) {
      case "invalidDate": {
        return "Le format est invalide";
      }
      default: {
        return "";
      }
    }
  }, [error]);

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleCardClick = (newPtr: number) => {
    setPtr(newPtr);
    setIsOpen(false);
  };

  const handleDelete = async () => {
    if (
      window.confirm(
        "Êtes-vous sûr(e) de vouloir supprimer tous les magasins sélectionnés?"
      )
    ) {
      setSelectedRow(null);
      setListMags([]);
      setOpenModalEdit(false);
      const deleteTask = storePlanograms.map((e) => {
        return new RequestToSend(
          `Supprimer planogramme ${e.magasin.mag_nom}`,
          deletePlanogramme,
          () => { },
          {},
          { plano_seq: e.plano_seq },
          []
        );
      });
      dispatch(addRequestsToSend(deleteTask));
    }
  };

  const handleSubmit = async () => {
    if (
      window.confirm(
        "Êtes-vous sûr(e) de vouloir modifier tous les magasins sélectionnés?"
      )
    ) {
      const updateTask = storePlanograms.map((e) => {
        const data = {
          mag_num: e.mag_num,
          plano_seq: e.plano_seq,
          prod_num: e.prod_num,
          plans_seq: e.plans_seq,
          plano_trsf_dt_entree:
            onFloorTransferDate !== undefined
              ? onFloorTransferDate.format("YYYY/MM/DD")
              : null,
          plano_trsf_dt_sortie:
            offFloorTransferDate !== undefined
              ? offFloorTransferDate.format("YYYY/MM/DD")
              : null,
          plano_qte: planoQuantity,
          plano_prod_num_remp: ptr,
          statut_aff: e.statut_aff,
          plano_plateau: plateau,
          plano_remplacer: remplacer,
        };
        return new RequestToSend(
          `Modification planogramme ${e.magasin.mag_nom}`,
          updatePlanogramme,
          () => {
            if (ensembleValues.length > 0)
              dispatch(
                addRequestToSend(
                  new RequestToSend(
                    `Sauvegarde produit/ensemble ${e.magasin.mag_nom}`,
                    updatePlanogrammeProduits,
                    () => { },
                    { planoSeq: data.plano_seq },
                    ensembleValues,
                    ["planogrammeProduits"]
                  )
                )
              );
          },
          {},
          data,
          []
        );
      });
      dispatch(addRequestsToSend(updateTask));
    }
  };

  useEffect(() => {
    console.log(plateau);
  }, [plateau]);

  return (
    <Box sx={{ p: 2 }} data-component="modification-lot-magasins">
      <GenericModal
        open={isOpen}
        handleClose={handleClose}
        title="PTR"
        style={getModalStyle}
      >
        <PTRModal handleCardClick={handleCardClick} />
      </GenericModal>
      <GenericModal
        open={showModalPlanoProduits}
        handleClose={() => setShowModalPlanoProduits(false)}
        title="Produits inclus"
        style={getModalStyle}
      >
        <PlanoProduitsModal
          prodNum={data.prod_num}
          ensembleValues={ensembleValues}
          closeModal={() => setShowModalPlanoProduits(false)}
          update={(values: any) => {
            setEnsembleValues(values);
          }}
        />
      </GenericModal>
      <Typography
        variant="h5"
        sx={{ fontWeight: "bold", ml: 2, color: "#007bff" }}
      >
        Modification en lot
      </Typography>
      <Box sx={{ display: "flex" }}>
        <Box
          display={"flex"}
          flexDirection={"column"}
        >
          <Box display={"flex"}>
            <TextField
              label="Quantité"
              type="number"
              sx={{ width: "75px", m: 1 }}
              InputLabelProps={{
                shrink: true,
              }}
              value={planoQuantity}
              InputProps={{ inputProps: { min: 1, max: 100 } }}
              onChange={(e) => {
                if (e.target.value !== "") {
                  setPlanoQuantity(Number(e.target.value));
                }
              }}
              disabled={ensemble.length > 0}
              onClick={(e) => {
                e.stopPropagation();
              }}
            />
            <DatePicker
              label="Date d'entrée"
              onChange={(event) => {
                setOnFloorTransferDate(event);
              }}
              sx={{ m: 1 }}
              onError={(newError) => setError(newError)}
              slotProps={{
                textField: {
                  helperText: errorMessage,
                },
              }}
              format="DD/MM/YYYY"
            />
            <DatePicker
              label="Date de sortie"
              onChange={(event) => {
                setOffFloorTransferDate(event);
              }}
              sx={{ m: 1 }}
              onError={(newError) => setError(newError)}
              slotProps={{
                textField: {
                  helperText: errorMessage,
                },
              }}
              format="DD/MM/YYYY"
            />
            <TextField
              type="search"
              label="Prend la place de"
              value={ptr}
              onBlur={() => {
                if (ptr) setPtr(ptr);
              }}
              onChange={(event) => {
                const value = event.currentTarget.value;
                const onlyDigitsRegex = /^\d+$/;

                const isOnlyDigits = onlyDigitsRegex.test(value);

                setPtr(isOnlyDigits ? parseInt(value) : null);
              }}
              sx={{ m: 1, width: 200, color: "#233044", background: "white" }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Button onClick={() => setIsOpen(true)}>
                      <SearchIcon />
                    </Button>
                  </InputAdornment>
                ),
              }}
            />

            <TextField
              value={plateau}
              label="Plateau"
              type="number"
              sx={{ m: 1, width: "5rem" }}
              onChange={(event) => {
                setPlateau(Number(event.currentTarget.value));
              }}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              flexShrink: 0,
              gap: 3,
            }}
          >
            {ensemble.length > 0 && (
              <TextField
                type="search"
                label="Produits inclus"
                value={
                  ensembleValues
                    .map((e) => padZerosLeft(e.prod_num, PTR_LENGTH))
                    .join(", ") || ""
                }
                sx={{
                  m: 1,
                  color: "#233044",
                  background: "white",
                  flexGrow: 1,
                }}
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <InputAdornment position="end">
                      <Button onClick={() => setShowModalPlanoProduits(true)}>
                        <EditIcon />
                      </Button>
                    </InputAdornment>
                  ),
                }}
              />
            )}
            <FormControlLabel
              control={<Checkbox />}
              label={"Remplacé"}
              checked={remplacer}
              onChange={(_event, checked) => setRemplacer(checked)}
            />
          </Box>
        </Box>
        {/* TODO: Refactor to reusable component */}
        <Tooltip title="Enregistrer">
          <span
            style={{
              display: "flex",
              alignItems: "center",
              padding: "6px 28px",
              cursor: "pointer",
            }}
            className={`save-wrapper ${!isValid || !planogramManagementRights.canModify
              ? "custom-disabled"
              : ""
              }`}
            onClick={handleSubmit}
          >
            <span className={`k-icon k-font-icon k-i-save k-icon-xl`}></span>
          </span>
        </Tooltip>
        {/* TODO: Refactor to reusable component */}
        <Tooltip title="Effacer">
          <span style={{ display: "flex" }}>
            <Button
              color="error"
              disabled={!planogramManagementRights.canDelete}
              onClick={handleDelete}
            >
              {" "}
              <DeleteIcon />
            </Button>
          </span>
        </Tooltip>
      </Box>
    </Box>
  );
};
